/**
 * src/utils/onboarding.js
 *
 * Shared helpers for reading and writing the onboarding-seen flag in
 * AsyncStorage. Centralised here so the initial OnboardingScreen flow can
 * operate on the same key and the persistence logic can be tested directly.
 */

import AsyncStorage from '@react-native-async-storage/async-storage';

/** AsyncStorage key — set to 'true' once the user has seen the onboarding. */
export const ONBOARDING_KEY = '@sleepMix_onboardingSeen';

/**
 * Write the "seen" flag.  Called by OnboardingScreen when the user finishes
 * or skips the flow.  May throw; callers should wrap in try/catch.
 */
export async function markOnboardingSeen() {
  await AsyncStorage.setItem(ONBOARDING_KEY, 'true');
}
